import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/views/Main.vue'
import Login from '@/views/Login/Login.vue'
import Home from '@/views/Home.vue'
import Profilo from "@/views/Profilo/Profilo.vue"
import GestioneUtente from "@/views/GestioneUtente/GestioneUtente.vue"
import Archivio from "@/views/Archivio/Archivio.vue"
import ArchivioFSCGruppo from "@/views/Archivio/ArchivioFSCGruppo.vue"
import ArchivioPEFCGruppo from "@/views/Archivio/ArchivioPEFCGruppo.vue"
import ArchivioISO9001 from "@/views/Archivio/ArchivioISO9001.vue"
import GestioneNews from "@/views/GestioneNews/GestioneNews.vue"
import PasswordReset from "@/views/PasswordReset/PasswordReset.vue"
import Operazioni from "@/views/Operazioni/Operazioni.vue"

import RegistroSintesi from "@/views/registroSintesi/RegistroSintesi.vue"
import ElencoClienti from "@/views/registroSintesi/ElencoClienti.vue"

import RegistroSintesiPEFC from "@/views/registroSintesiPEFC/RegistroSintesiPEFC.vue"
import ElencoClientiPEFC from "@/views/registroSintesiPEFC/ElencoClienti.vue"

import storage from '@/services/storage.js'

Vue.use(Router)

const routerOptions = [
  {
    path: '/',
    component: Main,
    meta: {
      checkAuth: true
    },
    children: [
      {
        path: '/',
        component: Home,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/account',
        component: Profilo,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/gestioneUtente',
        component: GestioneUtente,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/archivio',
        component: Archivio,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/audit-fsc-gruppo',
        component: ArchivioFSCGruppo,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/audit-pefc-gruppo',
        component: ArchivioPEFCGruppo,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/ISO9001',
        component: ArchivioISO9001,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/gestionaleNews',
        component: GestioneNews,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/operazioni',
        component: Operazioni,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/registro/:codice',
        component: RegistroSintesi,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/registro',
        component: ElencoClienti,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/registro-pefc/:codice',
        component: RegistroSintesiPEFC,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/registro-pefc',
        component: ElencoClientiPEFC,
        meta: {
          checkAuth: true
        }
      }
    ]
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/passwordreset',
    component: PasswordReset,
    meta: {
      title: "Password reset"
    }
  },
  {
    path: "*", // Pagine non trovate (redirect su /)
    beforeEnter: (to, from, next) => {
      next({
        path: '/'
      })
    }
  }
]


const rou = new Router({
  mode: 'history',
  routes: routerOptions
})


rou.beforeEach((to, from, next) => {

  // Controllo se è richiesta l'autenticazione
  if (to.meta.checkAuth && !storage.checkAuth()) {

    next({
      path: '/login'
    })

    return

  }
  // Controllo pagina login
  else if (to.path == "/login" && storage.checkAuth()) {

    // Se il login è stato fatto, vado alla pagina riservata
    next({
      path: '/'
    })
    return
  }

  next();

})



export default rou;